import {gql} from '@apollo/client'

export const GET_TICKETS = gql`
  query tickets(
    $search: String
    $policyId: ID
    $status: String
    $statuses: [String]
    $channel: String
    $priority: String
    $priorities: [String]
    $ticketTypeId: ID
    $ticketTypeIds: [ID]
    $assignmentType: String
    $assignedUserId: ID
    $assignedUserIds: [ID]
    $assignedGroupId: ID
    $assignedGroupIds: [ID]
    $createdById: ID
    $createdByIds: [ID]
    $createdAfter: Date
    $createdBefore: Date
    $dueAfter: DateTime
    $dueBefore: DateTime
    $includeArchived: Boolean
    $onlyOverdue: Boolean
    $onlyUnassigned: Boolean
    $inboxMode: String
    $pendingInbox: Boolean
    $includeSolvedClosed: Boolean
    $first: Int
    $offset: Int
  ) {
    tickets(
      search: $search
      policyId: $policyId
      status: $status
      statuses: $statuses
      channel: $channel
      priority: $priority
      priorities: $priorities
      ticketTypeId: $ticketTypeId
      ticketTypeIds: $ticketTypeIds
      assignmentType: $assignmentType
      assignedUserId: $assignedUserId
      assignedUserIds: $assignedUserIds
      assignedGroupId: $assignedGroupId
      assignedGroupIds: $assignedGroupIds
      createdById: $createdById
      createdByIds: $createdByIds
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      dueAfter: $dueAfter
      dueBefore: $dueBefore
      includeArchived: $includeArchived
      onlyOverdue: $onlyOverdue
      onlyUnassigned: $onlyUnassigned
      inboxMode: $inboxMode
      pendingInbox: $pendingInbox
      includeSolvedClosed: $includeSolvedClosed
      first: $first
      offset: $offset
    ) {
      totalCount
      items {
        id
        title
        observations
        channel
        externalReference
        status
        priority
        assignmentType
        dueAt
        firstResponseAt
        slaBreachedAt
        isArchived
        isDeleted
        isOverdue
        createdAt
        updatedAt
        closedAt
        ticketType {
          id
          name
          isActive
        }
        policyId
        assignedUser {
          id
          firstName
          lastName
          email
        }
        assignedGroup {
          id
          name
        }
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedBy {
          id
          firstName
          lastName
          email
        }
        firstResponseBy {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_OPEN_PENDING_TICKETS_COUNT = gql`
  query openPendingTicketsCount {
    tickets(
      status: "OPEN"
      pendingInbox: true
      includeArchived: false
      first: 1
      offset: 0
    ) {
      totalCount
    }
  }
`

export const GET_TICKET_BY_ID = gql`
  query ticketById($id: ID!) {
    ticketById(id: $id) {
      id
      title
      observations
      channel
      externalReference
      status
      priority
      assignmentType
      dueAt
      firstResponseAt
      slaBreachedAt
      isArchived
      isDeleted
      isOverdue
      createdAt
      updatedAt
      closedAt
      ticketType {
        id
        name
        description
        isActive
      }
      policyId
      assignedUser {
        id
        firstName
        lastName
        email
      }
      assignedGroup {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedBy {
        id
        firstName
        lastName
        email
      }
      firstResponseBy {
        id
        firstName
        lastName
        email
      }
      closedBy {
        id
        firstName
        lastName
      }
      notes {
        id
        comment
        createdAt
        author {
          id
          firstName
          lastName
          email
        }
      }
      attachments {
        id
        file
        originalName
        contentType
        fileSize
        createdAt
        uploadedBy {
          id
          firstName
          lastName
          email
        }
      }
      statusHistory {
        id
        previousStatus
        newStatus
        changedAt
        comment
        changedBy {
          id
          firstName
          lastName
          email
        }
      }
      changeLogs {
        id
        fieldName
        oldValue
        newValue
        changedAt
        comment
        changedBy {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_TICKET_TYPES = gql`
  query ticketTypes($isActive: Boolean) {
    ticketTypes(isActive: $isActive) {
      id
      name
      description
      isActive
    }
  }
`

export const GET_TICKET_METRICS = gql`
  query ticketMetrics(
    $search: String
    $policyId: ID
    $status: String
    $statuses: [String]
    $channel: String
    $priority: String
    $priorities: [String]
    $ticketTypeId: ID
    $ticketTypeIds: [ID]
    $assignmentType: String
    $assignedUserId: ID
    $assignedUserIds: [ID]
    $assignedGroupId: ID
    $assignedGroupIds: [ID]
    $createdById: ID
    $createdByIds: [ID]
    $createdAfter: Date
    $createdBefore: Date
    $dueAfter: DateTime
    $dueBefore: DateTime
    $includeArchived: Boolean
    $onlyOverdue: Boolean
    $onlyUnassigned: Boolean
    $inboxMode: String
    $pendingInbox: Boolean
  ) {
    ticketMetrics(
      search: $search
      policyId: $policyId
      status: $status
      statuses: $statuses
      channel: $channel
      priority: $priority
      priorities: $priorities
      ticketTypeId: $ticketTypeId
      ticketTypeIds: $ticketTypeIds
      assignmentType: $assignmentType
      assignedUserId: $assignedUserId
      assignedUserIds: $assignedUserIds
      assignedGroupId: $assignedGroupId
      assignedGroupIds: $assignedGroupIds
      createdById: $createdById
      createdByIds: $createdByIds
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      dueAfter: $dueAfter
      dueBefore: $dueBefore
      includeArchived: $includeArchived
      onlyOverdue: $onlyOverdue
      onlyUnassigned: $onlyUnassigned
      inboxMode: $inboxMode
      pendingInbox: $pendingInbox
    ) {
      openCount
      overdueCount
      unassignedCount
      myAssignedCount
      groupAssignedCount
      resolvedLast7Days
      avgResolutionHours
    }
  }
`

export const GET_TICKET_DASHBOARD = gql`
  query ticketDashboard(
    $search: String
    $policyId: ID
    $status: String
    $statuses: [String]
    $channel: String
    $priority: String
    $priorities: [String]
    $ticketTypeId: ID
    $ticketTypeIds: [ID]
    $assignmentType: String
    $assignedUserId: ID
    $assignedUserIds: [ID]
    $assignedGroupId: ID
    $assignedGroupIds: [ID]
    $createdById: ID
    $createdByIds: [ID]
    $createdAfter: Date
    $createdBefore: Date
    $dueAfter: DateTime
    $dueBefore: DateTime
    $includeArchived: Boolean
    $onlyOverdue: Boolean
    $onlyUnassigned: Boolean
    $inboxMode: String
    $pendingInbox: Boolean
    $days: Int
  ) {
    ticketDashboard(
      search: $search
      policyId: $policyId
      status: $status
      statuses: $statuses
      channel: $channel
      priority: $priority
      priorities: $priorities
      ticketTypeId: $ticketTypeId
      ticketTypeIds: $ticketTypeIds
      assignmentType: $assignmentType
      assignedUserId: $assignedUserId
      assignedUserIds: $assignedUserIds
      assignedGroupId: $assignedGroupId
      assignedGroupIds: $assignedGroupIds
      createdById: $createdById
      createdByIds: $createdByIds
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      dueAfter: $dueAfter
      dueBefore: $dueBefore
      includeArchived: $includeArchived
      onlyOverdue: $onlyOverdue
      onlyUnassigned: $onlyUnassigned
      inboxMode: $inboxMode
      pendingInbox: $pendingInbox
      days: $days
    ) {
      todaySubmitted
      todayResolved
      kpis {
        avgFirstResponseHours
        avgResolutionHours
        resolutionFirstTouchRate
        customerSatisfaction
      }
      statusCounts {
        status
        count
      }
      topSolvers {
        userId
        fullName
        email
        solvedCount
      }
      trend {
        day
        submitted
        resolved
      }
    }
  }
`
